module.exports = __webpack_public_path__ + "static/img/04OK.4c1f9a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/04OK.gif
// module id = Amla
// module chunks = 0